import store from '@/store/store';
import Env from '@/env';
/**
 * Route must be authenticate, if user is authenticated, push them to home
 */
export default async function visitorAgeVerify({ next, router, to }) {

    let queries = to.query
    const visitor = store.getters.getVisitorDetails;
    // If any page has noage = true, Dont need to verify age
    if( (queries.noage == 1) || 
        (queries.noage == 'true') || 
        (queries.in_store == 1) || 
        (queries.in_store == 'true') ||  
        (queries.kiosk == 1) || 
        (queries.kiosk == 'true') ) 
    {
      if (visitor.ageVerify == false) {
        store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: '',
          remember: false,
        });
      }
    } else {
      // If visitor has not verify age he must, redirect to verification page
      if (visitor.ageVerify == false) {
        return router.push({ 
          name: 'VisitorAgeVerification', 
          params: { 
            business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug, 
          },
          query: to.query
        });
      }
    }
    return next();

    // If user is not logged in and in_store=1 then we must redirect user to anonymous page for login and back to same page
    // if( !store.getters.getLoggedInUserId && queries.in_store && (to.name != 'AddAnonymous') ){
    //   // Check for business slug and location slug
    //   if(to.params.business_slug && to.params.store_slug){
    //     store.dispatch('location/setGuestLandedQueries', queries);
    //     store.dispatch('SET_LANDING_ROUTE', to.fullPath);
    //     return router.push({ 
    //       name: 'AddAnonymous', 
    //       params: { 
    //         business_slug: to.params.business_slug, 
    //         store_slug: to.params.store_slug, 
    //       },
    //     });
    //   }
    // }

    // lets check if we land on store profile /landing
    // if( (to.name == 'StoreProfile') || (to.name == 'StoreLanding') ){
      // and has meta like hide banner or hide map
      // if(queries['hide-map'] == 'true' || queries['hide-banner'] == 'true' || queries['guest-only'] == 'true' || queries['kiosk'] == 'true' || queries['kiosk'] == 1 ){
      //   // this mean we have loaded on iframe we dont need to verify age
      //   store.dispatch('SET_VISITOR_DETAILS', {
      //     ageVerify: true,
      //     dob: '',
      //     province: '',
      //     remember: false,
      //   });     
      //   //store.dispatch('location/setGuestLandedQueries', queries);
      // } else {
        
        // if (visitor.ageVerify === false) {
        //   return router.push({ 
        //     name: 'VisitorAgeVerification', 
        //     params: { 
        //       business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug, 
        //     },
        //     query: {
        //       access_type: queries.access_type 
        //     }
        //   });
        // }
    //  }
    // } else {
    //   const visitor = store.getters.getVisitorDetails;
    //   if (visitor.ageVerify === false) {
    //     return router.push({ 
    //       name: 'VisitorAgeVerification', 
    //       params: { 
    //         business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug, 
    //       },
    //       query: {
    //         access_type: queries.access_type 
    //       }
    //     });
    //   }
    // }
  
  // return next();
}
